import React from 'react'
import ExpensesTransactions from 'src/app/ExpensesTransactions/ExpensesTransactions'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { myWalletTransactionsRouteProps } from 'src/navigation/routeProps'

const MyWalletTransactionsAppRoute: AppRoute = {
  id: AppLocation.MyWalletTransactions,
  routeProps: myWalletTransactionsRouteProps,
  component: <ExpensesTransactions myTransactions />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default MyWalletTransactionsAppRoute
